import axios, { AxiosResponse } from 'axios';

import { EEmitentJe } from 'enums/isin/emitentJe';

export interface IEmitent {
    vypis: number;
    upis: string;
    srd: string;
    adminwr: number;
    upissicav?: boolean;
    smlouvydodatky?: boolean;
    dluznik: boolean;
    neplatneaml?: boolean;
    datplatamlz?: string;
    c2edit?: boolean;
    amlz?: 'NOVY' | 'ZADOST' | 'EDITOVAT' | 'OSOBY';
    typemitenta?: EEmitentJe;
    crsHotovo?: boolean;
    omezprev?: boolean;
}

const emitentApi = () => {
    return axios({
        method: 'GET',
        url: '/Portal/Emitent'
    }).then((resp: AxiosResponse<IEmitent>) => resp.data);
};
export default emitentApi;
